import React, { useCallback, useRef, useState, useEffect } from 'react';

import { Link, useHistory } from 'react-router-dom';
import { FormHandles } from '@unform/core';

import * as Yup from 'yup';
import QrReader from 'react-qr-reader';

import { Container, Content, AnimatedDiv, Fixed } from './styles';

import Button from '../../core/components/Forms/Button';
import getValidationErrors from '../../../../utils/getValidationErrors';
import api from '../../../../services/api';
import { useToast } from '../../../../hooks/Toast';

import { useAuth } from '../../../../hooks/Auth';
import { isUuid, uuid } from 'uuidv4';
import { useSearch } from '../../../../hooks/Search';
import { Form } from '@unform/web';
import Input from 'src/components/Forms/Input';



interface ICheckin {
  accept_multiple?: number;
  room_id?: number;
  title?: string;
}

interface IStudents {
  name: string;
  document_number: string;
  user_hash: string;
}

const CheckinQRList: React.FC<ICheckin> = ({
  accept_multiple = 2,
  room_id = 0,
  title = 'Leitor',
}) => {
  const history = useHistory();
  const { addToast } = useToast();
  const [withPassword, setWithPassword] = useState(false);
  const formRef = useRef<FormHandles>(null);
  const [result, setResult] = useState('');
  const [camera, setCamera] = useState('environment');
  const [lastBeep, setLastBeep] = useState('');
  const [responseStatus, setResponseStatus] = useState(false);
  const [responseMessage, setResponseMessage] = useState(<></>);
  const [option, setOption] = useState(2);
  const [quantity, setQuantity] = useState(0);
  const [inputValue, setInputValue] = useState('');
  const { user } = useAuth();
  const { reloadSearchAll } = useSearch();
  const ref = useRef(null);
  const [currentRoom, setCurrentRoom] = useState('');
  const [type, setType] = useState('leitor');
  const [keyCode, setKeyCode] = useState('code')
  useEffect(() => {

    if (!user) {
      window.location.href = '/';
    }

  }, [currentRoom]);



  const beep = () => {
    const snd = new Audio(
      'data:audio/wav;base64,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',
    );
    snd.play();
  };

  function beeps(vol, freq, duration) {
    const a = new AudioContext(); // browsers limit the number of concurrent audio contexts, so you better re-use'em
    const v = a.createOscillator();
    const u = a.createGain();
    v.connect(u);
    v.frequency.value = freq;
    v.type = 'square';
    u.connect(a.destination);
    u.gain.value = vol * 0.01;
    v.start(a.currentTime);
    v.stop(a.currentTime + duration * 0.001);
  }

  const clearAll = () => {
    setResponseStatus(false);
    setResponseMessage(<></>);
    setResult('');
    setLastBeep('');
  };

  const loadResult = async (responseData) => {
    const response = responseData?.rows?.[0];

    if (!response) {
      setResponseMessage(
        <Fixed background="orange">
          <h2>Erro ao identificar ingresso</h2>
          <button onClick={clearAll}>Fechar</button>
        </Fixed>,
      );
    }


    if (response) {
      setResponseMessage(
        <Fixed background={'green'}>
          <h2 style={{ fontSize: '36px', marginBottom: '20px' }}>Confirmado</h2>
          <strong style={{ fontSize: '32px', marginBottom: '20px' }}>Nome: {response?.name}</strong>


          <button onClick={clearAll}>Fechar</button>
        </Fixed>,
      );
      beep();
      await api.post(`/confirm-student-access/${response?.user_hash}/${user.project_id}`);
      reloadSearchAll();
    }



    setResponseStatus(true);
    setTimeout(() => clearAll(), 3000);
  };

  const handleSubmit = async (data: string) => {
    try {
      const dataItems = await api.get(`/students-list-presence`, {
        params: {
          where: {

            user_hash: data
          }
        }
      });

      if (dataItems && dataItems.data) {
        loadResult(dataItems.data);
      }
    } catch (err) {
      if (err instanceof Yup.ValidationError) {
        const errors = getValidationErrors(err);
        formRef.current?.setErrors(errors);
      }

      addToast({
        type: 'error',
        title: 'Erro ao verificar',
        description: 'Ocorreu um erro ao verificar o código',
      });
    }
  };





  const handleScan = async data => {
    setResult(data);
    if (data) {
      setLastBeep(data);
      handleSubmit(data);
      setResult(data);
    }
    setKeyCode(uuid())
  };

  const handleError = err => {
    console.error(err);
  };

  return (<>

    <Container>
      {responseStatus && responseMessage}
      <Content>

        <button style={{ color: '#fff', background: '#333', padding: '10px', borderRadius: '10px', cursor: 'pointer' }} type='button' onClick={() => setType('camera')}> Leitor de câmera </button>
        <button style={{ color: '#fff', background: '#333', padding: '10px', borderRadius: '10px', cursor: 'pointer' }} type='button' onClick={() => setType('leitor')}> Leitor de QRCode </button>
        <AnimatedDiv>




          <h2>{title}</h2>
          <select name="camera" onChange={e => setCamera(e.target.value)}>
            <option value="environment">Padrão</option>
            <option value="user">Alternativa</option>
          </select>
          <div style={{ width: '100%', maxWidth: '100%', height: '100vh' }}>
            {type === 'camera' ? <QrReader
              facingMode={camera}
              delay={500}
              onError={handleError}
              onScan={handleScan}
              style={{ width: '100%' }}
            /> : <></>}


            {type === 'leitor' ? <Form className='column gap' onSubmit={(data) => handleScan(data.code)}>
              <p style={{ color: '#333', textAlign: 'center', width: '100%' }}>Insira o código de leitura</p>
              <Input focus={true} key={keyCode} name='code' placeholder='' />
              <button style={{ color: '#fff', background: '#333', padding: '10px', borderRadius: '10px', cursor: 'pointer' }}>Enviar</button>
            </Form> : <></>}

            <p>{result}</p>
          </div>
        </AnimatedDiv>







      </Content>
    </Container>
  </>
  );
};

export default CheckinQRList;
